<template>
  <section class="mt-12 lg:mt-20 px-2 bg-white">
      <p class="text-center text-2xl lg:text-3xl font-bold" style="color: #062648">Our management team</p>
      <div class="mt-8 py-8 lg:py-12" style="background-color: #E8F2F9">
        <ul class="pl-3 flex figlist2 gap-10 lg:gap-0">
          <li v-for="mgt in management" :key="mgt.id" class="relative">
            <figure>
              <div>
                <img :src="`${baseURL}/staff/${mgt.picture}`" onerror="this.onerror=null;this.src='https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg';" alt="" class="figimg">
              </div>
              <figcaption class="text-center">
                <p class="font-bold text-gray-500 text-sm">{{mgt.fullname}}</p>
                <p class="text-blue-900 font-light text-sm">{{mgt.position}}</p>
              </figcaption>
            </figure>
              <div class="details hidden rounded shadow-lg absolute right-0 bg-white top-0 py-6 px-6">
                <p class="font-bold text-sm">{{mgt.fullname}}</p>
                <p class="mt-2 text-sm" style="color:#062648">{{mgt.position}}</p>
                <p class="mt-4 text-gray-500 text-xs leading-6">{{mgt.about}}</p>
                <!-- <font-awesome-icon icon="angle-down" /> -->
              </div>
          </li>
        </ul>
      </div>
    </section>
</template>

<script>
import baseURL from '@/main'
export default {
  props: ['management'],
  data(){
    return {
      baseURL: baseURL
    }
  }
}
</script>

<style scoped>
.figimg{
  width: 150px;
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
}
figure div{
  border: 1px solid #062648;
  background-color: #fff;
  border-radius: 50%;
  padding: 7px;
  text-align: center;
}
figcaption{
  margin-top: 10px;
}
.figlist2{
  flex-wrap: wrap;
  
}
.figlist2 li{
  max-width: 43%;
  position: relative
}


@media only screen and (min-width: 1024px){
.figlist2 li:hover > div.details{
  display: block;
}
div.details{
  width: 350px;
  max-height: 500px;
  overflow-x: auto;
  overflow-y: auto;
  top: -50px;
  right: -350px;
  z-index: 100
}
.details::-webkit-scrollbar
{
  width: 0px;
	background-color: #F5F5F5;
}
  .figlist2{
    padding-left: 80px;
    padding-right: 40px;
  }
  .figlist2{
    margin-left: 30px;
  }
  .figlist2 li{
    width: 13%;
    min-width: 150px;
    margin: 20px 30px;
  }
}

</style>